import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { Reviews } from '../components/Reviews';
import { WhyUs } from '../components/WhyUs';
import { GoalsGrid } from '../components/GoalsGrid';
import { ScienceSection } from '../components/ScienceSection';
import { LabTesting } from '../components/LabTesting';
import { FAQ } from '../components/FAQ';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-background" data-id="element-1356">
      <AnnouncementBar data-id="element-1357" />
      <Header data-id="element-1358" />
      <main data-id="element-1359">
        <Hero data-id="element-1360" />
        <TrustStrip data-id="element-1361" />
        <FeaturedProducts data-id="element-1362" />
        <Reviews data-id="element-1363" />
        <WhyUs data-id="element-1364" />
        <GoalsGrid data-id="element-1365" />
        <ScienceSection data-id="element-1366" />
        <LabTesting data-id="element-1367" />
        <FAQ data-id="element-1368" />
        <Newsletter data-id="element-1369" />
      </main>
      <Footer data-id="element-1370" />
    </div>;
}